
import { Component, Vue } from 'vue-property-decorator';
import { orderTrajectory } from '@/api/orderService';
import { UserModule } from '@/store/modules/user';
@Component({
  name: 'PathTracking'
})
export default class extends Vue {
  created() {
    let _this = this;
    AMapUI.load(['ui/misc/PathSimplifier'], function(PathSimplifier:any) {
      if (!PathSimplifier.supportCanvas) {
        _this.$message.error('当前环境不支持 Canvas！');
        return;
      }
      // 启动页面
      _this.initPage(PathSimplifier);
    });
  }
  private pheight = window.innerHeight;
  private marker:any = [];

  private map:any = null;
  private pathSimplifierIns:any = null;
  private colors = [
    '#0076ff', '#e7553e', '#88c158', '#f5ba46', '#9479da',
    '#d46fab', '#3aadd9', '#35ba9b', '#bdbe44 ', '#e2b691'
  ];
  private getPathData:any = [];

  private currentPathData:any = [];
  private currentColors:any = [];
  // order_id=67419&order_service_id=67710&servicer_company_id=24701
  private initData(PathSimplifier:any) {
    let data = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      order_id: this.$route.query.order_id,
      servicer_company_id: this.$route.query.servicer_company_id
    };
    orderTrajectory(data)
      .then(res => {
        if (res.data) {
          this.getPathData = res.data.getPathData;
          for (let i = 0; i < this.getPathData.length; i++) {
            this.getPathData[i].color = this.colors[i];
            this.getPathData[i].index = i;
            if (i === 0) {
              this.getPathData[i].select = true;
            } else {
              this.getPathData[i].select = false;
            }
          }
          this.getMapMarker(this.getPathData[0]);
          this.pathSimplifierIns.setData(this.getLineData(this.getPathData[0]));
          this.pathSimplifierIns.createPathNavigator(0, // 关联第1条轨迹
            {
              loop: true, // 循环播放
              speed: 10000
            }).start();
        } else {
          this.getPathData = [];
        }
      })
      .catch(err => {
        let msg = err.msg;
      });
  }
  private getLineData(val:any) {
    var temp = [];
    temp.push(val);
    return temp;
  }
  private initPage(PathSimplifier:any) {
    let _this = this;

    _this.map = new AMap.Map('pathContainer', {
      zoom: 4
    });

    // 创建组件实例
    _this.pathSimplifierIns = new PathSimplifier({
      zIndex: 100,
      map: _this.map, // 所属的地图实例
      getPath: function(pathData:any, pathIndex:any) {
        // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
        if (pathData.path && pathData.path.length > 0) {
          return pathData.path;
        }
      },
      getHoverTitle: function(pathData:any, pathIndex:any, pointIndex:any) {
        // 返回鼠标悬停时显示的信息
        if (pointIndex >= 0) {
          // 鼠标悬停在某个轨迹节点上
          return pathData.name;
        }
        // 鼠标悬停在节点之间的连线上
        return pathData.name;
      },
      renderOptions: {
        // 轨迹线的样式
        pathLineStyle: {
          dirArrowStyle: true
        },
        getPathStyle(pathItem:any, zoom:any) {
          let lineWidth = Math.round(2 * Math.pow(1.1, zoom - 3));

          return {
            pathLineStyle: {
              strokeStyle: pathItem.pathData.color,
              lineWidth: lineWidth
            },
            pathLineHoverStyle: {
              strokeStyle: pathItem.pathData.color
            },
            pathLineSelectedStyle: {
              strokeStyle: pathItem.pathData.color,
              lineWidth: lineWidth + 2
            },
            pathNavigatorStyle: {
              fillStyle: pathItem.pathData.color,
              pathLinePassedStyle: {
                strokeStyle: pathItem.pathData.color
              }
            }
          };
        }
      }
    });
    this.initData(PathSimplifier);
  }
  private getMapMarker(val:any) {
    let _this = this;
    let positions = [];
    let markerHtml = [];
    _this.marker = [];
    if (val.setout && val.setout.length > 0) {
      markerHtml.push('<div class="map-custom-content-marker" style="background: ' + '#1FC17D' + '">出发</div>');
      positions.push(val.setout);
      // _this.marker[0] = new AMap.Marker({
      //   position: val.setout,
      //   // 将 html 传给 content
      //   content: '<div class="map-custom-content-marker-top" style="background: ' + val.color + '">' + val.name + '</div>',
      //   // 以 icon 的 [center bottom] 为原点
      //   offset: new AMap.Pixel(-9, -48)
      // });
      // _this.map.add(_this.marker[0]);
    }

    if (val.checkin && val.checkin.length > 0) {
      markerHtml.push('<div class="map-custom-content-marker" style="background: ' + '#3684EC' + '">签到</div>');
      positions.push(val.checkin);
      // if (!(val.setout && val.setout.length > 0)) {
      //   _this.marker[0] = new AMap.Marker({
      //     position: val.setout,
      //     // 将 html 传给 content
      //     content: '<div class="map-custom-content-marker-top" style="background: ' + val.color + '">' + val.name + '</div>',
      //     // 以 icon 的 [center bottom] 为原点
      //     offset: new AMap.Pixel(-9, -48)
      //   });
      //   _this.map.add(_this.marker[0]);
      // }
    }

    if (val.finish && val.finish.length > 0) {
      markerHtml.push('<div class="map-custom-content-marker" style="background: ' + '#FC4C22' + '">完成</div>');
      positions.push(val.finish);
      // if (!(val.setout && val.setout.length > 0) && !(val.checkin && val.checkin.length > 0)) {
      //   _this.marker[0] = new AMap.Marker({
      //     position: val.setout,
      //     // 将 html 传给 content
      //     content: '<div class="map-custom-content-marker-top" style="background: ' + val.color + '">' + val.name + '</div>',
      //     // 以 icon 的 [center bottom] 为原点
      //     offset: new AMap.Pixel(-9, -48)
      //   });
      //   _this.map.add(_this.marker[0]);
      // }
    }
    if (_this.marker && _this.marker.length === 1) {
      for (let m = 0; m < positions.length; m++) {
        _this.marker[m + 1] = new AMap.Marker({
          position: positions[m],
          // 将 html 传给 content
          content: markerHtml[m],
          // 以 icon 的 [center bottom] 为原点
          offset: new AMap.Pixel(-9, -13)
        });

        _this.map.add(_this.marker[m + 1]);
      }
    } else {
      for (let m = 0; m < positions.length; m++) {
        _this.marker[m] = new AMap.Marker({
          position: positions[m],
          // 将 html 传给 content
          content: markerHtml[m],
          // 以 icon 的 [center bottom] 为原点
          offset: new AMap.Pixel(-9, -13)
        });

        _this.map.add(_this.marker[m]);
      }
    }
  }
  private engineerPathHandle(val:any, index:any) {
    // 切换工程师轨迹
    let _this = this;
    for (let i = 0; i < this.getPathData.length; i++) {
      let cont = this.getPathData[i];
      cont.select = false;
      this.$set(this.getPathData, i, cont);
    }
    let cont = this.getPathData[index];
    cont.select = true;
    this.$set(this.getPathData, index, cont);

    _this.map.remove(_this.marker);
    this.$nextTick(() => {
      _this.getMapMarker(val);
      this.pathSimplifierIns.setData(this.getLineData(val));
      if (val.path.length !== 0) {
        _this.pathSimplifierIns.clearPathNavigators();
        _this.pathSimplifierIns.createPathNavigator(0, // 关联轨迹
          {
            loop: true, // 循环播放
            speed: 10000
          }).start();
      } else {
        this.$notify.info({
          title: '消息',
          message: '该工程师暂未轨迹'
        });
      }
    });
  }
}
